export function isLocalStorageSupported(): boolean {
  try {
    const ls = globalThis.localStorage
    const x = '__storage_test__'
    ls.setItem(x, x)
    ls.removeItem(x)
    return true
  } catch {
    return false
  }
}
